import { useField } from 'formik';
import { Box, Flex } from 'reflexbox';
import styled, { useTheme } from 'styled-components';
import { rgba } from 'polished';

import TalentReviewCellColorBar from './TalentReviewCellColorBar';
import TalentReviewLabel from './TalentReviewLabel';

const Container = styled(Box)`
	margin-left: 10px;
`;

const CellToolbar = styled(Box)`
	position: absolute;
	top: 100%;
	transform: translateY(-50%);
	background: white;
`;

const CellToolbarUp = styled(Box)`
	height: 50%;
	width: 100%;
	background: ${(props) => props.theme.colors.whiteBlue};
	position: absolute;
`;

const CellContainer = styled(Flex)<{ hex: string }>`
	flex-grow: 0;
	flex-shrink: 0;
	background: ${(props) => props.theme.colors.whiteBlue};
	width: 160px;
	min-height: 120px;
	border-radius: 6px;
	position: relative;
	color: ${(props) => props.hex};

	align-items: center;
	justify-content: center;

	border: 2px solid ${(props) => rgba(props.hex, 0.5)};
`;

const Instruction = styled(Flex)`
	margin-top: 20px;
	justify-content: center;

	color: ${(props) => props.theme.colors.slateBlue};
`;

export default function TalentReviewCell(props: { name: string }) {
	const theme = useTheme() as any;
	const [{ value: color }] = useField<number>(props.name + '.color');
	const hex = `#${color.toString(16).padStart(6, '0')}`;

	return (
		<Container>
			<CellContainer hex={hex}>
				<TalentReviewCellColorBar name={props.name + '.color'} />

				<CellToolbar>
					<CellToolbarUp />
					<Box style={{ position: 'relative' }}>
						<TalentReviewLabel hex={hex} name={props.name + '.label'} />
					</Box>
				</CellToolbar>
			</CellContainer>
			<Instruction>
				<TalentReviewLabel
					multiline
					hex={theme.colors.slateBlue}
					name={props.name + '.instruction'}
				/>
			</Instruction>
		</Container>
	);
}
